import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const DepartmentList = Loadable(lazy(() => import('./DepartmentList')));
const AddDepartment = Loadable(lazy(() => import('./AddDepartment')));
const PrivateRoute = Loadable(lazy(() => import('../../auth/PrivateRoute')));

const DepartmentRoutes = [
  {
    path: '/Department/list',
    element: (
      //<PrivateRoute pageUrl="DepartmentMaster" requiredFunc="VIE">
        <DepartmentList />
      //</PrivateRoute>
    ),
    auth: authRoles.admin,
  },
  {
    path: '/Department/manage',
    element: (
      <PrivateRoute pageUrl="DepartmentMaster" requiredFunc="ADD">
        <AddDepartment />
      </PrivateRoute>
    ),
    auth: authRoles.admin,
  },
];

export default DepartmentRoutes;
